import React from 'react';

import type { DisplayProps } from '@rover/kibble/core';
import type { Props as SectionProps } from '@rover/kibble/patterns/Section';
import LandingRoverProtect from '@rover/react-lib/src/pages/landing/components/LandingRoverProtect';
import {
  PageSectionId,
  useSectionRef,
} from '@rover/react-lib/src/pages/landing/SeoLocation/hooks/useSectionRef';

type Props = SectionProps & {
  isGrooming?: boolean;
  headingTextColor?: DisplayProps['textColor'];
};

const SeoLocationRoverProtect = (sectionProps: Props): JSX.Element => {
  const sectionRef = useSectionRef(PageSectionId.RoverGuarantee);

  return <LandingRoverProtect htmlRef={sectionRef} {...sectionProps} />;
};

export default SeoLocationRoverProtect;
